/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { PageContentMessage } from "../../../messages";

const MODULE_NAME =
  "services.CollectionPageService.machines.GetPageContent.state.formatBreadcrumb";
const log = LoggerModule?.getInstance();

export const formatBreadcrumb = async (context: any, event: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const msg = context?.input as PageContentMessage;
      if (msg?.breadcrumbItems) {
        if (msg?.ancestors) {
          for (const anc of msg?.ancestors) {
            msg?.breadcrumbItems?.push({
              id: anc?.uuid,
              name: anc?.name,
              link: `/collection/${anc?.uuid}`,
            });
          }
          if (msg?.node?.uuid && msg?.node?.name) {
            msg?.breadcrumbItems?.push({
              id: msg?.node?.uuid,
              name: msg?.node?.name,
              link: `/collection/${msg?.node?.uuid}`,
            });
          }
        }
      }
      return resolve(true);
    } catch (err: any) {
      log?.error(MODULE_NAME, "error in formatBreadcrumb", err);
      return reject(err?.message);
    }
  });
};
